import { Component, OnInit, ViewChild } from '@angular/core';
import { IonCheckbox } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { SelectionGiftCardComponent } from '../../../../componentsAdmin/selection-gift-card/selection-gift-card.component';

@Component({
  selector: 'app-users-gift-card',
  templateUrl: './users-gift-card.component.html',
  styleUrls: ['./users-gift-card.component.scss'],
})
export class UsersGiftCardComponent implements OnInit {
  @ViewChild('checkboxAll', { static: true }) checkbox: IonCheckbox;
  private _search = '';
  public users = [];
  public selected = false;
  public noChanges = false;

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private trSv: TranslateService
  ) {}

  ngOnInit() {
    this.checkbox.ionChange.subscribe(() => {
      if (!this.noChanges) {
        this.selectAll();
      }
    });
    this.getUsers();
  }

  dismarkSelected() {
    const nonSelected = !!this.users.find((item) => !item.checked);
    if (nonSelected) {
      this.selected = false;
    } else {
      this.selected = true;
    }

    if (this.checkbox.checked !== this.selected) {
      this.noChanges = true;
    }
    this.checkbox.checked = this.selected;
  }

  selectAll() {
    const nonSelected = !!this.users.find((item) => !item.checked);
    if (nonSelected) {
      this.users.map((item) => (item.checked = true));
    } else {
      this.users.map((item) => (item.checked = false));
    }
  }

  async getUsers() {
    try {
      const params = {
        pag: '',
        rollId: '',
        search: this._search,
      };
      const res: any = await this.httpSv.itemIndex('admin/user', '', params);
      res.data.forEach((item) => (item.checked = false));
      this.users.push(...res.data);
      // this._totalPages = res.data.meta.last_page;
    } catch (err) {
      console.error(err);
    }
  }

  async continue() {
    const checkedUsers = this.users.filter((item) => item.checked);
    const users = checkedUsers.map((item) => item.id);
    if (!users.length) {
      const tr = this.trSv.instant(
        'DEBES_SELECCIONAR_AL_MENOS_UN_USUARIO_ANTES_DE_CONTINUAR'
      );
      return await this.uiSv.presentAlert(tr);
    }
    await this.uiSv.showModal(SelectionGiftCardComponent, { users });
  }
}
